<template>
  <div class="contents">
    <haken-kinmu-list />

    <div class="button-container">
      <p class="prev-page">
        <a @click="back">戻る</a>
      </p>
    </div><!--button-container-->

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import HakenKinmuList from '@/components/kinmu/HakenList.vue'
import { RouterConst } from '@/const/Router'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { PermissionConst } from '@/const/Permission'

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()
    const back = (() => {
      if(authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)){
        toSoumuCheck()
      } else if(authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)) {
        toHakenSyouninList()
      } else{
        // 基本的にこの画面は総務か派遣先上長しかみれないので、それ以外は想定外としてマイタスクへ戻らせる
        // ※将来的には派遣先上長も見れなくなるのでその時はこの一連の分岐を外してOK
        router.push({name: RouterConst.MY_TASK})
      }
    })

    // マイタスク　総務確認タブへ移動
    const toSoumuCheck = (() => {
      router.push(
        { name: RouterConst.MY_TASK, params: { from: RouterConst.HAKEN_KINMU_LIST } }
      );
    });

    // マイタスク 派遣先上長タブへ移動
    const toHakenSyouninList = (() => {
      router.push(
        { name: RouterConst.MY_TASK, params: { from: RouterConst.HAKEN_KINMU_LIST } }
      );
    });
    return {
      RouterConst,
      back
    }
  },
  components: {
    'haken-kinmu-list': HakenKinmuList,
  }
})
</script>
